import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";

import mhero1Img from "../../../assets/images/entry/mhero1.png";
import mhero2Img from "../../../assets/images/entry/mhero2.png";
import voyahFreeImg from "../../../assets/images/entry/voyahfree.png";
import voyahDreamImg from "../../../assets/images/entry/voyahdream.png";
import voyahTaishanImg from "../../../assets/images/entry/voyahtaishan.png";
import kajLogo from "../../../assets/images/kajlogo.png";

const MHERO_MODELS = [
  { name: "MHERO 1", subtitle: "917", path: "/mhero1", image: mhero1Img },
  { name: "MHERO 2", subtitle: "M817", path: "/mhero2", image: mhero2Img },
];

const VOYAH_MODELS = [
  { name: "FREE", path: "/voyahfree", image: voyahFreeImg, accent: "#b1c8d8" },
  { name: "DREAM", path: "/voyahdream", image: voyahDreamImg, accent: "#dddae3" },
  {
    name: "TAISHAN",
    path: "/voyahtaishan",
    image: voyahTaishanImg,
    accent: "#9a8bb8",
    featured: true,
  },
];

const VehicleCard = ({ model, brand, large }) => (
  <Link
    to={model.path}
    className={`home-vehicle ${large ? "home-vehicle--large" : ""} ${
      model.featured ? "home-vehicle--featured" : ""
    }`}
    style={{ "--vehicle-accent": model.accent || "#63bfc2" }}
  >
    <div className="home-vehicle-bg" aria-hidden="true" />
    <div className="home-vehicle-stage">
      <img src={model.image} alt={model.name} className="home-vehicle-img" />
    </div>
    <div className="home-vehicle-meta">
      <span className="home-vehicle-brand">{brand}</span>
      <h2 className="home-vehicle-name">{model.name}</h2>
      {model.subtitle && (
        <p className="home-vehicle-sub">{model.subtitle}</p>
      )}
      <span className="home-vehicle-link">
        Discover
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <path
            d="M5 12h14M13 6l6 6-6 6"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </div>
  </Link>
);

const Home = () => {
  return (
    <div dir="ltr" className="home">
      <div className="home-mesh" aria-hidden="true" />

      <header className="home-intro">
        <div className="home-intro-inner">
          <div className="home-kaj-logo-wrap">
            <img src={kajLogo} alt="KAJ Models" className="home-kaj-logo" />
          </div>
          <div className="home-intro-copy">
            <h1 className="home-headline">
              Discover our vehicle <em>models!</em>
            </h1>
            <p className="home-lead">
              Select a Vehicle to View Full Specifications & Features
            </p>
          </div>
        </div>
      </header>

      <main className="home-showroom">
        <section className="home-block">
          <div className="home-block-head">
            <span className="home-block-num">01</span>
            <h3 className="home-block-title">MHERO</h3>
            <span className="home-block-line" />
          </div>
          <div className="home-block-grid home-block-grid--mhero">
            {MHERO_MODELS.map((model) => (
              <VehicleCard
                key={model.path}
                model={model}
                brand="MHERO"
                large
              />
            ))}
          </div>
        </section>

        <section className="home-block">
          <div className="home-block-head">
            <span className="home-block-num">02</span>
            <h3 className="home-block-title">VOYAH</h3>
            <span className="home-block-line" />
          </div>
          <div className="home-block-grid home-block-grid--voyah">
            {VOYAH_MODELS.map((model) => (
              <VehicleCard
                key={model.path}
                model={model}
                brand="VOYAH"
                large={model.featured}
              />
            ))}
          </div>
        </section>
      </main>

      <footer className="home-foot">
        © {new Date().getFullYear()} MHERO & VOYAH
      </footer>
    </div>
  );
};

export default Home;
